import ContentTextEditor from './ContentTextEditor'

export default ContentTextEditor
